import React, {Fragment} from 'react';
import PriceSummary from '@homeaway/react-price-summary';
import InstantBookIcon from '../../MultiUnitCard/MultiUnitCardItems/InstantBookIcon/InstantBookIcon';

import './Price.less';

const Price = ({priceSummary, messages}) => {
    return !!priceSummary && !!priceSummary.amount ? (
        <PriceSummary priceSummary={priceSummary} />
    ) : (
        <span className="Price Price--noPrice" data-wdio="Price" data-price="0">
            <span className="Price__Fallback">{messages.ratesNone}</span>
        </span>
    );
};

export default function PriceWithInstantBook(props) {
    return (
        <Fragment>
            {props.instantBookable && <InstantBookIcon {...props} />}
            <Price {...props} />
        </Fragment>
    );
}
